import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormContext, FormErrorTypes } from 'dash-ui';
import {
  DashValidation,
  isDescriptionLengthValid,
  isEmptyOrNil,
  isNameLengthValid,
  isUrlValid,
} from 'dash-common';

import { FormFields } from './AccountInfoForm.constants';

export const useValidation = () => {
  const { errorHandlers } = useContext(FormContext);
  const { t } = useTranslation();

  const validateFieldByName = (fieldName: FormFields, value: string) => {
    const setInvalid = (message: string, values?: Record<string, string>) => {
      errorHandlers[fieldName]({
        type: FormErrorTypes.Invalid,
        message: t(message, values || {}),
      });
    };

    switch (fieldName) {
      case FormFields.FirstName: {
        if (isEmptyOrNil(value)) {
          setInvalid(`forms:messages.nameBlank`);
          return false;
        }
        if (!isNameLengthValid(value)) {
          setInvalid('forms:messages.maxCharacterLimit', {
            number: DashValidation.MaxNameLength.toString(),
          });
          return false;
        }
        break;
      }
      case FormFields.LastName: {
        if (isEmptyOrNil(value)) {
          setInvalid(`forms:messages.nameBlank`);
          return false;
        }
        if (!isNameLengthValid(value)) {
          setInvalid('forms:messages.maxCharacterLimit', {
            number: DashValidation.MaxNameLength.toString(),
          });
          return false;
        }
        break;
      }
      case FormFields.AgencyName: {
        if (value && !isNameLengthValid(value)) {
          setInvalid('forms:messages.maxCharacterLimit', {
            number: DashValidation.MaxNameLength.toString(),
          });
          return false;
        }

        break;
      }
      case FormFields.AgencyWebsite: {
        if (value && !isUrlValid(value)) {
          setInvalid('forms:messages.urlInvalid');
          return false;
        }
        break;
      }
      case FormFields.ShortDescription: {
        if (value && !isDescriptionLengthValid(value)) {
          setInvalid('forms:messages.maxCharacterLimit', {
            number: DashValidation.MaxDescriptionLength.toString(),
          });
          return false;
        }
        break;
      }
      case FormFields.BrokerLicenseNumber: {
        const brokerLicenseNumber = value as string;
        if (!brokerLicenseNumber) return true;
        //temp disable by request
        //   if (!isBrokerLicenseValid(value as string)) {
        //     setInvalid('forms:messages.invalidCharacters');
        //     return false;
        //   }
        if (brokerLicenseNumber.length > DashValidation.BrokerLicenseLength) {
          setInvalid('forms:messages.digitsLengthRestriction', {
            number: DashValidation.BrokerLicenseLength.toString(),
          });
          return false;
        }
        break;
      }
      case FormFields.PhoneNumber: {
        //disabled because the phone mask makes this validation broken
        // const phone = value as string;
        // if (!Number.isInteger(parseInt(phone))) {
        //   setInvalid('forms:messages.invalidCharacters');
        //   return false;
        // }
        break;
      }
      case FormFields.Place: {
        if (!value) {
          setInvalid('forms:messages.addressBlank');
          return false;
        }
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };

  return validateFieldByName;
};
